import styled from 'styled-components'

import { ResponsiveImage, TypeStyle, fromLg } from '@syconium/little-miss-figgy'
import { InfoButton } from '@syconium/little-miss-figgy/dist/components/AttributeSection/styles'

import {
  CrossedOutPrice,
  DiscountPrice,
  Price,
} from '../../../../../brunswick/components/PriceDisplay/styles'
import {
  FitSection,
  SizeSection,
} from '../../../../../brunswick/components/VariantAttributeSelectors/styles'

export const ProductTitle = styled(TypeStyle.HeadlineExtraExtraSmall).attrs({
  asTag: 'span',
})``

export const Tile = styled.li`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${fromLg} {
    flex-direction: row;
    padding: ${o => o.theme.spacing(6, 0)};
  }
`

export const TileRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 0;
`

export const TileText = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${o => o.theme.spacing(2)};
  padding-right: ${o => o.theme.spacing(4)};
  gap: ${o => o.theme.spacing(1)};
  ${fromLg} {
    padding-left: ${o => o.theme.spacing(4)};
    gap: ${o => o.theme.spacing(2)};
    width: 240px;
  }
`

export const MobilePlusMinus = styled.span`
  display: flex;
  align-items: center;
  gap: ${o => o.theme.spacing(4)};
  padding-right: ${o => o.theme.spacing(4)};

  ${fromLg} {
    display: none;
  }
`

export const DesktopBriefDescription = styled(TypeStyle.BodySmall).attrs({ asTag: 'p' })`
  display: none;
  font-weight: ${o => o.theme.typography.font.weight[400]};
  ${fromLg} {
    display: block;
  }
`

export const MobileBriefDescription = styled(TypeStyle.BodySmall).attrs({ asTag: 'p' })`
  display: block;
  font-weight: ${o => o.theme.typography.font.weight[400]};
  padding-bottom: ${o => o.theme.spacing(4)};
  ${fromLg} {
    display: none;
  }
`

export const PriceAndColor = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: ${o => o.theme.spacing(1)};
`

export const Contents = styled.div<{ $showMobile: boolean }>`
  display: ${({ $showMobile }) => ($showMobile ? 'flex' : 'none')};
  flex: 1;
  flex-direction: column;
  padding: ${o => o.theme.spacing(4)};

  ${fromLg} {
    display: flex;
    flex: 3;
    flex-direction: row;
    padding-top: ${o => o.theme.spacing(3)};
  }
`

export const VariantAttributeSelectorsWrapper = styled.div`
  flex: 3;

  ${FitSection} {
    margin-top: ${o => o.theme.spacing(6)};
  }

  ${SizeSection} {
    margin-top: ${o => o.theme.spacing(2.5)};
  }
  ${InfoButton} {
    svg {
      width: 16px;
      height: 16px;
    }
  }
`

export const ButtonCtaWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${o => o.theme.spacing(4)};
  padding-top: ${o => o.theme.spacing(4)};

  ${fromLg} {
    padding-left: ${o => o.theme.spacing(6)};
    padding-top: 0;
    min-width: 180px;
  }
`

export const TileImage = styled(ResponsiveImage)`
  height: 85px;
  width: 85px;

  ${fromLg} {
    height: 250px;
    width: 200px;
  }
`

export const ViewProductMobile = styled(TypeStyle.BodyTiny)`
  font-weight: ${o => o.theme.typography.font.weight[600]};
  letter-spacing: 1px;
  padding-bottom: ${o => o.theme.spacing(4)};
  text-decoration-line: underline;
  text-transform: uppercase;

  ${fromLg} {
    display: none;
  }
`
export const PriceWrapper = styled.div`
  ${Price}:not(${DiscountPrice}) {
    color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
  }
  ${CrossedOutPrice},
  ${DiscountPrice},
  ${Price} {
    font-size: ${o => o.theme.typography.font.size[11]};

    ${fromLg} {
      font-size: ${o => o.theme.typography.font.size[14]};
    }
  }
`
